import { transformVersionToCountryFlag } from '../transform/versionToCountryFlag';

Vue.component('ais-icon-refinement-list-item', {
  template: "#ais-icon-refinement-list-item",
  props: {
    item: { type: Object, required: true },
    refine: { type: Function, required: true },
    type: { type: String, default: 'icon' },
    size: { type: String, default: '1em' },
    shape: { type: String, default: 'Circle' },
    customColors: { type: Object, default: () => ({}) },
  },
  data: () => ({
    defaultColors: {
      // Additional colors that can be used: multicolor, mehrfarbig, bunt
      beige: "#f5f5dc",
      schwarz: "#000000",
      black: "#000000",
      blau: "#0000ff",
      bronze: "#cd7f32",
      kupfer: "#cd7f32",
      braun: "#a52a2a",
      klar: "#d0d0d0",
      transparent: "#d0d0d0",
      gold: "#ffd700",
      grau: "#808080",
      grün: "#008000",
      orange: "#ffa500",
      rosa: "#ffc0cb",
      lila: "#800080",
      rot: "#ff0000",
      silber: "#c0c0c0",
      türkis: "#40e0d0",
      weiss: "#ffffff",
      weiß: "#ffffff",
      white: "#ffffff",
      gelb: "#ffff00"
    },
  }),
  methods: {
    getVersionCountryFlagSrc (versionName) {
      return transformVersionToCountryFlag(versionName);
    },
    getColorStyle (colorName) {
      const colors = { ...this.defaultColors, ...this.customColors };
      const color = colors[colorName];

      return color && {
        backgroundColor: color,
      };
    },
    getContrastColor (rgb) {
      const [r, g, b] = rgb;
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? 'black' : 'white';
    },
  },
});
